import { render, staticRenderFns } from "./RiskStatus.vue?vue&type=template&id=3c142e8e&"
import script from "./RiskStatus.vue?vue&type=script&lang=js&"
export * from "./RiskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports